// extracted by mini-css-extract-plugin
module.exports =  {"adminIntercomSettingsTeamInboxes":"hz6hVNFA","description":"UD1Pnnxu","error":"ZNvMPMxt","filterContainer":"Dy6g_hml","saveButton":"dDYJbY8B","saveError":"mKPv0_rX"};